import React from 'react'

function Footer() {
  const getYear = () => {
    const year = new Date().getFullYear();
    return year;
  }
  return (
    <>
      <div className="footer">
        <span>
          © {getYear()}, Snaxsmart. All Rights Reserved.
        </span>
      </div>
    </>
  )
}

export default Footer